document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('form[action^="/cart/add"]');
  var galleryItems = document.querySelectorAll('[data-variant-ids]');
  if (!form || !galleryItems.length) return;

  function filterGallery() {
    
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? idInput.value : null;

    galleryItems.forEach(function (item) {
      var ids = item.dataset.variantIds.split(',').filter(Boolean);
      var showItem = ids.length === 0 || ids.indexOf(variantId) !== -1;
      item.hidden = !showItem;
    });
  }
  
  filterGallery();

  form.addEventListener('change', function () {
    setTimeout(filterGallery, 50);
  });
});
